<style lang="scss">
html {
  height: 100vh;
  width: 100%;
}

.rechner-all {
  border: 0px solid red;
}

.info-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 600px;

  @media (max-width: 992px) {
    max-width: 100%;
  }

  h1 {
    text-align: center;

    @media (max-width: 992px) {
      font-size: 20px !important;
    }
  }
}
</style>

<template>
  <div class="calculator content container">
    <!--
    <div class="info-box">
      <h1>Der Druckkostenkalkulator wird überarbeitet und steht Ihnen in Kürze wieder zur Verfügung.</h1>
    </div>
    -->
    <div class="rechner-all">
      <Tarifrechner :tarifData="tarifData"> </Tarifrechner>
    </div>
  </div>
</template>

<script type="ts">
import { defineComponent, ref } from 'vue';
import Tarifrechner from '@/components/tarifrechner/Tarifrechner.vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'Calculator',
  components: {
    Tarifrechner,
  },
  setup() {
    const store = useStore();
    const tarifData = ref(store.state.tarifrechner);

    return {
      tarifData,
    };
  },
});
</script>
